const Helpers = require('../helpers/_helpers.js');
/**
 * Modal component.
 * All DOM elements with classname '.js-modal' will open their target on click.
 *
 * Usage:
 * Call modal.init() to initialize all modals.
 *
 * Methods:
 *
 * init(): attaches eventlisteners to all modal triggers
 * initFor($selector): attaches eventlisteners for one modal. Expects the selector to have a data-modal-target value.
 * openModal(id): toggles modal programmatically by id
 * closeModals(): closes all open modals
 */

const $rootEl = document.documentElement,
	$modals = document.querySelectorAll('.modal'),
	$triggers = document.querySelectorAll('.js-modal'),
	$modalCloses = document.querySelectorAll('[data-modal-close], .modal');

const initFor = $el => {
	$el.addEventListener('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		const $target = $el.dataset.modalTarget;
		openModal($target);
	});
}

const openModal = target => {
	const $target = document.getElementById(target);
	$rootEl.classList.add('has-modal-open');
	$target.classList.add('is-active');
}

const closeModals = () => {
	$rootEl.classList.remove('has-modal-open');
	$modals.forEach(function($el) {
		$el.classList.remove('is-active');
		
		const $videos = $el.querySelectorAll("video");
		
		//stop html5 video's
		$videos.forEach(function($vid){
			$vid.pause();
		});
		
		//stop youtube embed video's
		if (!!window.yt_players) {
			window.yt_players.forEach(function(p) {
				//doesn't work on localhost, YT player doesn't add the functions :(
				if (typeof p.stopVideo === "function") { 
					p.stopVideo();	
				}

			});
		}
		
	});
}

const init = () => {
	if ($triggers.length > 0) {
		$triggers.forEach($el => {
			initFor($el);
		});
	}

	// register close buttons
	$modalCloses.forEach(function($el) {
		$el.addEventListener('click', function(e) {
			e.stopPropagation();
			if (e.target == $el) closeModals();

		});
	});

	// close modals on ESC
	document.addEventListener('keydown', function(event) {
		const e = event || window.event;
		if (e.keyCode === 27) {
			closeModals();
		}
	});
};

module.exports = {
	init,
	initFor,
	openModal,
	closeModals
};
